import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AnimatedButton from "../AnimatedButton/AnimatedButton";

const rubikfont = {
    fontFamily: "Rubik, san-serif"
};

const Layout1 = ({ data }) => {
    const products = data?.product_id || [];
    const navigate = useNavigate();

    const handleProductClick = (productId) => {
        navigate(`/product/${productId}`);
        window.scrollTo(0, 0);
    };

    return (
        <Paper sx={{ py: { xs: 5, md: 8 }, padding: { xs: 2, md: 4 }, boxShadow: "none", backgroundColor: "#F6F4EF" }}>
            {/* Heading title*/}
            <Typography
                variant="h4"
                align="center"
                sx={{
                    fontSize: { xs: "32px", sm: "48px", md: "56px" },
                    color: "#222",
                    ...rubikfont,
                    fontWeight: 900,
                    lineHeight: 1.1,
                    letterSpacing: "3.5px",
                    textTransform: "uppercase",
                    mt: 2
                }}
            >
                {data?.title}
            </Typography>

            <Typography
                align="center"
                sx={{
                    fontSize: { xs: "14px", sm: "16px" },
                    color: "#666",
                    mb: { xs: 4, md: 6 },
                    ...rubikfont,
                }}
            >
                Curated selection of our best-selling grooming essentials
            </Typography>

            {/* Product Grid */}
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: {
                        xs: "repeat(2, 1fr)",
                        sm: "repeat(2, 1fr)",
                        md: "repeat(5, 1fr)",
                    },
                    gap: { xs: 2, sm: 3, md: 4 },
                }}
            >
                {products.map((product, index) => (
                    <Box
                        key={product._id || index}
                        onClick={() => handleProductClick(product._id)}
                        sx={{
                            bgcolor: "white",
                            borderRadius: 2,
                            overflow: "hidden",
                            transition: "all 0.3s ease",
                            cursor: "pointer",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                            "&:hover": {
                                transform: "translateY(-8px)",
                                boxShadow: "0 15px 30px rgba(0,0,0,0.15)",
                                "& .product-image": {
                                    transform: "scale(1.08)",
                                },
                                "& .add-to-cart-btn": {
                                    opacity: 1,
                                    transform: "translateY(0)",
                                },
                            },
                        }}
                    >
                        {/* Product Image */}
                        <Box
                            sx={{
                                position: "relative",
                                paddingTop: "90%",
                                overflow: "hidden",
                                bgcolor: "#f8f8f8",
                            }}
                        >
                            <img
                                src={product.product_images?.[0] || "https://via.placeholder.com/300"}
                                alt={product.title}
                                className="product-image"
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    transition: "transform 0.4s ease",
                                }}
                            />

                            {/* B2B Discount Badge */}
                            {product.b2b_discountValue && (
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: 8,
                                        left: 8,
                                        bgcolor: "#FF6B35",
                                        color: "white",
                                        px: 1.5,
                                        py: 0.5,
                                        borderRadius: 1,
                                        fontSize: { xs: "11px", sm: "12px", md: "13px" },
                                        fontWeight: 600,
                                        ...rubikfont,
                                        zIndex: 2,
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                    }}
                                >
                                    {product.b2b_discountType === "percentage" 
                                        ? `${product.b2b_discountValue}% OFF`
                                        : `₹${product.b2b_discountValue} OFF`
                                    }
                                </Box>
                            )}

                            
                        </Box>

                        {/* Product Details */}
                        <Box sx={{ p: { xs: 1, sm: 1, md: 2 } }}>
                            <Typography
                                sx={{
                                    fontSize: { xs: "13px", sm: "15px", md: "16px" },
                                    fontWeight: 500,
                                    color: "#222",
                                    // mb: 1.5,
                                    ...rubikfont,
                                    minHeight: { xs: "32px", sm: "38px", md: "40px" },
                                }}
                            >
                                {product.title}
                            </Typography>
                            {/*b2b_sellingPrice */}
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <Typography
                                    sx={{
                                        fontSize: { xs: "16px", sm: "18px", md: "20px" },
                                        fontWeight: 700,
                                        color: "#222",
                                        ...rubikfont,
                                    }}
                                >
                                    ₹{product.b2b_sellingPrice}
                                </Typography>
                                {/*b2c_mrp */}
                                {product.b2c_mrp && (
                                    <Typography
                                        sx={{
                                            fontSize: { xs: "13px", sm: "14px", md: "16px" },
                                            color: "red",
                                            textDecoration: "line-through",
                                            ...rubikfont,
                                        }}
                                    >
                                        ₹{product.b2c_mrp}
                                    </Typography>
                                )}
                            </Box>
                        </Box>
                    </Box>
                ))}
            </Box>
            {/* View All Button */}
            <Box sx={{ textAlign: "center", mt: 6, display: "flex", gap: 3, flexWrap: "wrap", justifyContent: "center" }}>
                <AnimatedButton text="View All  →" onClick={() => navigate('/search', { state: { layoutId: data._id, title: data.title } })} />
            </Box>
        </Paper>
    );
};

export default Layout1;
